import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { DmcQuoteTermsConditionsComponent } from '../terms-conditions/dmc-quote-terms-conditions.component';
import { DmcQuotePaymentsTermsConditionsComponent } from '../payments-terms-conditions/dmc-quote-payments-terms-conditions.component';
import { DmcQuoteCancellationPolicyComponent } from '../cancellation-policy/dmc-quote-cancellation-policy.component';

@Component({
  selector: 'app-dmc-quote-combined-terms',
  templateUrl: './dmc-quote-combined-terms.component.html',
  styleUrls: ['./dmc-quote-combined-terms.component.scss'],
})
export class DmcQuoteCombinedTermsComponent implements OnInit {

  @Input() leadId: any;
  @Input() itineraryId: any;
  @Output() viewChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  isDirty: boolean = false;

  @Input() editQuote: boolean = false;

  @Input() inclusionsAndExclusionsFormData: any;
  @Input() termsAndConditionsFormData: any;
  @Input() paymentTermsAndConditionsFormData: any;
  @Input() cancellationPolicyFormData: any;

  @Output() storeInclusionsFormData: EventEmitter<any> = new EventEmitter();
  @Output() storeTermsFormData: EventEmitter<any> = new EventEmitter();
  @Output() storePaymentTermsFormData: EventEmitter<any> = new EventEmitter();
  @Output() storeCancellationPolicyFormData: EventEmitter<any> = new EventEmitter();

  @Output() updateQuote: EventEmitter<void> = new EventEmitter();


  @Input() hideFooter: boolean = false;


  @ViewChild(DmcQuoteTermsConditionsComponent) termsAndConditionsComponent!: DmcQuoteTermsConditionsComponent;
  @ViewChild(DmcQuotePaymentsTermsConditionsComponent) paymentTermsAndConditionsComponent!: DmcQuotePaymentsTermsConditionsComponent;
  @ViewChild(DmcQuoteCancellationPolicyComponent) cancellationPolicyComponent!: DmcQuoteCancellationPolicyComponent

  constructor(
    private _globalService: GlobalService
  ) { }

  ngOnInit() { }

  resetAllChildComponents() {
    this.termsAndConditionsComponent.ngOnInit();
    this.paymentTermsAndConditionsComponent.ngOnInit();
    this.cancellationPolicyComponent.ngOnInit();
    this.isDirty = false;
  }

  async onSubmit(): Promise<boolean> {
    try {
      const termsResult = await this.termsAndConditionsComponent.onSubmit();
      if (!termsResult) {
        console.error("Terms and Conditions submission failed.");
        return false;
      }

      if (this.leadId) {
        const paymentTermsResult = await this.paymentTermsAndConditionsComponent.onSubmit();
        if (!paymentTermsResult) {
          console.error("Payment Terms and Conditions submission failed.");
          return false;
        }
      }

      const cancellationPolicyResult = await this.cancellationPolicyComponent.onSubmit();
      if (!cancellationPolicyResult) {
        console.error("Cancellation Policy submission failed.");
        return false;
      }

      if (this.editQuote) {
        this.updateQuote.emit();
      }

      this.isDirty = false; // Reset dirty state only if all submissions are successful
      return true;
    } catch (error) {
      console.error("Error during the submission process:", error);
      return false;
    }
  }


  storeInclusionsAndExclusionData(event: any) {
    this.storeInclusionsFormData.emit(event);
  }
  storeTermsAndConditionsData(event: any) {
    this.storeTermsFormData.emit(event)
  }
  storePaymentTermsAndConditionsData(event: any) {
    this.storePaymentTermsFormData.emit(event)
  }
  storeCancellationPolicyData(event: any) {
    this.storeCancellationPolicyFormData.emit(event)
  }

  markFormDirty(event: any) {
    this.isDirty = event;
  }
  async resetForm() {
    if (await this._globalService.confirmActionPopup("Confirm to reset data", "Confirm", "Confirm")) {
      this.resetAllChildComponents();
    }
  }

  goPrevious() {
    this.viewChange.emit(true);
  }

  goNext() {
    this.viewChange.emit(false);
  }

  async saveAndNext() {
    if (await this.onSubmit()) {
      this.goNext()
    }
  }

  formDataModified(): boolean {
    return this.isDirty;
  }

}
